import React from "react";
import { SOCIAL_PROOF } from "../landingData";

const SocialProofSection = () => (
    <section className="clk-section clk-section-proof" id="proof">
        <div className="clk-container">
            <div className="clk-proof-layout clk-reveal">
                <blockquote className="clk-proof-quote">
                    <p>&ldquo;{SOCIAL_PROOF.quote}&rdquo;</p>
                    <footer>
                        <strong>{SOCIAL_PROOF.name}</strong>
                        <span>{SOCIAL_PROOF.role}</span>
                    </footer>
                </blockquote>
                <div className="clk-proof-stats">
                    {SOCIAL_PROOF.stats.map((s) => (
                        <div key={s.label} className="clk-proof-stat">
                            <span className="clk-proof-stat-val">{s.value}</span>
                            <span className="clk-proof-stat-lbl">{s.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default SocialProofSection;
